// extracted by mini-css-extract-plugin
export default {"icon":"SubscriptionsBellButton_icon__TWUHo","whiteIcon":"SubscriptionsBellButton_whiteIcon__Z5cGL"};